import React from "react";
import styles from "./GuideSection.module.scss";
import Title from "components/title/Title";
import openCallImage from "../../../assets/images/open-call-image.jpg";
import GuideCard from "components/cards/guideCard/GuideCard";

const openCallObj = {
  image: openCallImage,
  title: "Title Open Call For Artists 2025",
  description:
    "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock.",
};

const grantObj = {
  image: openCallImage,
  title: "Title Grant For Artists 2025",
  description:
    "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock.",
};

const GuideSection = () => {
  return (
    <div className={styles.guideSectionContainer}>
      <div className="container">
        <Title text={"Guide"} bottomStrokeWidth={"63%"} />
        <div className={styles.guideSection}>
          <div className={styles.subSectionTitle}>Open Calls</div>
          <GuideCard item={openCallObj} />
          <GuideCard item={openCallObj} />
        </div>
        <div className={styles.guideSection}>
          <div className={styles.subSectionTitle}>Grants</div>
          <GuideCard item={grantObj} />
          <GuideCard item={grantObj} />
        </div>
      </div>
    </div>
  );
};

export default GuideSection;
